module.exports = __webpack_public_path__ + "img/Decoration_lumineuse.3519e2b.jpg";